import { Typography } from 'antd';
import useAuth from 'hooks/useAuth';
import { absenceTypesType } from 'utils';
const { Text } = Typography;
const StaffLeaveCalendarFooter = ({
  absenceType,
  isGetTobeApprove,
}: {
  absenceType: object[];
  isGetTobeApprove: boolean;
}) => {
  const { user } = useAuth();
  const role = user?.role;

  const headerAbsence = [
    role !== 'admin' && {
      bg: '#1E87A1',
      name: 'Other absence',
    },
  ];

  if (isGetTobeApprove)
    headerAbsence.push({
      bg: '#FFEF5F',
      name: 'To be approved',
    });
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
        gap: '2em',
        width: '70vw',
        padding: '20px',
        // justifyContent:'space-between',
      }}
    >
      {[...headerAbsence, ...absenceType]?.map(
        (item: absenceTypesType, index: number) => (
          <div
            key={index}
            style={{
              display: !item || item['bg'] === null ? 'none' : 'flex',
              gap: '8px',
              alignItems: 'center',
              justifyItems: 'center',
            }}
          >
            <span
              style={{
                background: item['bg'],
                width: 20,
                height: 20,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: `${item['color']}`,
                borderRadius: 5,
                fontSize: 12,
                padding: 1,
              }}
            >
              {item['code']}
            </span>
            <Text
              ellipsis={{ tooltip: item.name }}
              style={{
                fontWeight: 500,
                color: '#000000',
              }}
            >
              {item.name}
            </Text>
          </div>
        ),
      )}
    </div>
  );
};

export default StaffLeaveCalendarFooter;
